import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'
import { Link } from 'react-router-dom'
 
import { Button } from 'primereact/button';
import {Password} from 'primereact/password';

import { resetPassword, login } from '@actions/auth';

import { regexOnlyNumbersAndLetters } from '@utils/general'


// import './style.scss'

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnSubmitLoading: false,
      email: '',
      password: '',
      confirmPassword: '',
      errors: [],
    };
  }

  componentDidMount () {
    const { history } = this.props
    if (!history?.location?.state?.email) return history.push("/forgot-password")
    return this.setState({email: history?.location?.state?.email})
  }

  onChange = ({ target }) => {
    const newValue = target.value.replace(regexOnlyNumbersAndLetters, '')
    this.setState({ [target.name]: newValue }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t } = this.props;
    const { password, confirmPassword } = this.state;
    let errors = {};
    if (!password) errors = { ...errors, 'password': `${t('Contraseña')} ${t('es requerido')}` }
    else if (!(password.length >= 8 && password.length <=12)) errors = { ...errors, 'password': `${t('Debe tener un minimo de 8 y maximo de 12')}` }
    else if (!(/([0-9]+)/g.test(password))) errors = { ...errors, 'password': `${t('Debe incluir al menos un número')}` }
    
    if (!confirmPassword) errors = { ...errors, 'confirmPassword': `${t('Confirmar contraseña')} ${t('es requerido')}` }
    else if(password !== confirmPassword) errors = { ...errors, 'confirmPassword': `${t('Las cotraseñas no coinciden')}` }
    this.setState({ errors });
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { history, resetPassword, login } = this.props
    const { confirmPassword, email } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const response = await resetPassword({ email, confirmPassword })
    if (!response.status) {
      const loginResponse = await login({ email, password: confirmPassword })
      if (!loginResponse?.status) {
        this.setState({ btnSubmitLoading: false });
        return history.push("/reset-password-success")
      }
    }
    return this.setState({ btnSubmitLoading: false });
  };

  render() {
    const { t } = this.props;
    const { password, confirmPassword, btnSubmitLoading, errors } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

      const footer = (
        <>
            <p className="p-mt-2">Suggestions</p>
            <ul className="p-pl-2 p-ml-2 p-mt-0" style={{lineHeight: '1.5'}}>
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li>Minimum 8 characters</li>
            </ul>
        </>
    );

    return (
      <section className="loginCont is-full-height p-d-flex p-jc-center p-ai-center">
        <div className="conteiner">
          <div className="p-grid">
            <div className="p-col-12 card p-p-6">
              <div className="p-grid containerForm">
                <div className="p-col-3">
                  <Link to="/" className="logo">
                    <img src="/assets/img/logo-compliance.svg" width="117" height="100" alt="Programa integridad y cumplimiento Compromiso de todos" />
                  </Link>
                </div>
                <form onSubmit={this.onSubmit} className="p-col-6 p-fluid p-pt-5">
                  <h2 className="p-mb-6 p-text-center p-mt-5"> {t("Personaliza tu contraseña")} </h2>
                  <div className="p-field">
                    <label
                      htmlFor="code"
                    >
                      {t("Contraseña")}
                    </label>
                    <Password
                      name="password"
                      value={password}
                      onChange={this.onChange}
                      maxLength={12}
                      autoFocus
                      toggleMask
                      // footer={footer}
                      // header={(<div></div>)}
                      // content={(<div></div>)}
                      feedback={false}
                      className={classNames({
                        'p-invalid': isFormFieldValid(`password`),
                      })}
                    />
                    {getFormErrorMessage('password')}
                  </div>
                  <div className="p-field">
                    <label
                      htmlFor="code"
                    >
                      {t("Confirmar contraseña")}
                    </label>
                    <Password
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={this.onChange}
                      maxLength={12}
                      toggleMask
                      feedback={false}
                      className={classNames({
                        'p-invalid': isFormFieldValid(`confirmPassword`),
                      })}
                    />
                    {getFormErrorMessage('confirmPassword')}
                  </div>
                  <Button type="submit" label={t("Continuar")} className="p-button p-mt-4" loading={btnSubmitLoading} loadingoptions={{ position: 'right' }}/>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapDispatchToProps = {
  resetPassword,
  login
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(ResetPassword);
